import React from 'react';

const ShareButton = (props) => {
    const encodedUrl = encodeURI(props.url)
    const encodedText = encodeURI(props.text+"\n")
    const encodedTags = encodeURI("ジャッジ,judge,2択,決めて,運命の決断,チョイス")
    return (
        <>
            {(props.type === 'twitter') && (
                <a href={"https://twitter.com/intent/tweet?url="+encodedUrl+"&text="+encodedText+"&hashtags="+encodedTags}
                   className={"p-btn__share-twitter"} rel="nofollow" target= "_blank" rel="noopener noreferrer" role={"button"}>Twitter</a>
            )}
            {(props.type === 'line') && (
                <a href={"http://line.me/R/msg/text/?"+encodedText+"%20"+encodedUrl}
                   className={"p-btn__share-line"} rel="nofollow" target= "_blank" rel="noopener noreferrer" role={"button"}>LINE</a>
            )}
            {(props.type === 'facebook') && (
                <a href={"https://www.facebook.com/sharer/sharer.php?u="+encodedUrl+"&t="+encodedText} className={"p-btn__share-facebook"}
                   rel="nofollow" target= "_blank" rel="noopener noreferrer" role={"button"}>Facebook</a>
            )}
        </>
    );
};
export default ShareButton;